import { useSelector } from 'react-redux'
import { SurveyContext } from '../../../../types/Survey/Survey'
import props from '../../../../redux/props'
import { formatNumber, getPrettyDateTime, prettyLocation } from '../../../../utility'
import { ChartPieIcon, Square3Stack3DIcon } from '@heroicons/react/24/outline'
import Upsert from '../Upsert/Upsert'
import { useState } from 'react'
import Modal from '../../../UI/Modal/Modal'

type Props = { data: SurveyContext; pullList: () => void }

const Item: React.FC<Props> = ({ data, pullList }) => {
  const t = useSelector((s) => s[props.TRANSLATION])
  const [open, setOpen] = useState<boolean>(false)

  const toggle = () => setOpen(!open)

  return (
    <div className="flex w-full items-center gap-2">
      <div className="w-2/12 cursor-pointer hover:underline" onClick={toggle}>
        {data.departmentName}
      </div>
      <div className="w-1/12">{t.survey.attributes.professionalGroupOption[data.professionalGroup]}</div>
      <div className="w-2/12 truncate">{prettyLocation(data.location)}</div>
      <div className="w-2/12">{formatNumber(data.employeeAmount)}</div>
      <div className="w-2/12">{getPrettyDateTime(data.deadline)}</div>
      <div className="w-2/12">{formatNumber(data.totalAnswerCount)}</div>
      <div className="w-1/12 flex justify-center">
        <Upsert initData={data} pullList={pullList} />
      </div>
      <Modal noForm show={open} onClose={toggle} closeIcon invert>
        <div className="flex flex-col gap-3 mt-3">
          <a
            className="p-3 flex gap-3 flex-row items-center bg-white hover:bg-lightGray group h-full transition-all outline-none"
            href={`/admin/survey/analysis/${data.uuid}`}
          >
            <ChartPieIcon className="w-10 stroke-blue" />
            <div className="font-bold text-center text-lg text-blue group-hover:underline">{t.survey.list.selection.analysis}</div>
          </a>
          <div className="flex flex-col gap-3 justify-between">
            {data.surveyList.map((s) => (
              <a
                className="p-3 flex gap-5 items-center bg-white hover:bg-lightGray group transition-all outline-none"
                key={s.uuid}
                href={`/admin/survey/configuration/${s.uuid}`}
              >
                <Square3Stack3DIcon className="w-10 stroke-blue" />
                <div className="font-bold text-center text-lg text-blue group-hover:underline">{t.survey.type[s.surveyType]}</div>
              </a>
            ))}
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default Item
